<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!--        <div v-if="$gate.isBranchManager()">-->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
    <br>

    <br>
    <div class="col-lg-12">
        <div class="card card-danger card-outline collapsed-card">
            <div class="card-header">
                <div class="card-title">Data Filters</div>
                <div class="card-tools">
                    <!-- Collapse Button -->
                    <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                </div>
            </div>
            <div class="card-body">
                <div class="col-lg-12 float-left">
                    <div class="row">
                        <div class="col-sm-4">
                            <span class="right badge badge-secondary">Results per page:</span>
                            <div class="form-group">
                                <input class="form-control" placeholder="Enter the results" v-model="results" type="number" min="1">
					        </div>
                        </div>
                        <div class="col-sm-4" v-if='$gate.isZonalManager()==true || $gate.isMISAdmin()==true'>
                            <div class="form-group">
                                <span class="right badge badge-secondary">Branch:</span>
                                <select class="form-control" v-model="params.branch">
                                    <option v-for="branch in branches" :value="branch.branch_code">{{branch.branch}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Created |From Date:</span>
                                <input type="date" class="form-control" v-model="params.from_date" placeholder="From date">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Created |To Date:</span>
                                <input type="date" class="form-control" v-model="params.to_date" placeholder="To date">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Phone Number:</span>
                                <input class="form-control" placeholder="Enter a phone number" v-model="params.phone" type="number" min="1000000000">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">SAP Doc Number:</span>
                                <input class="form-control" placeholder="Enter SAP Doc Number" v-model="params.sapdoc" type="text">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Gatepass Number:</span>
                                <input class="form-control" placeholder="Enter gatepass" v-model="params.gatepass" type="number" min="1">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Receipt Used:</span>
                                <select class="form-control" v-model="params.used">
                                    <option value="1">Used</option>
                                    <option value="0">Unused</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Cancelled:</span>
                                <select class="form-control" v-model="params.cancelled">
                                    <option value="1">Cancelled</option>
                                    <option value="0">Not Cancelled</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Receipt Against:</span>
                                <select class="form-control" v-model="params.against">
                                    <option value="SI">Sale Invoice</option>
                                    <option value="SO">Sale Order</option>
                                    <option value="RC">RC</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Order ID:</span>
                                <input class="form-control" placeholder="Enter order no." v-model="params.order_id" type="number" min="1">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Draft Order ID:</span>
                                <input class="form-control" placeholder="Enter draft order no." v-model="params.draft_order_id" type="number" min="1">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Receipt ID:</span>
                                <input class="form-control" placeholder="Enter receipt no." v-model="params.receipt_id" type="number" min="1">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Min Amount:</span>
                                <input class="form-control" placeholder="Enter the min amount" v-model="params.minimum" type="number" min="0">
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <span class="right badge badge-secondary">Max Amount:</span>
                                <input class="form-control" placeholder="Enter the max amount" v-model="params.maximum" type="number" min="0">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <button class="btn btn-primary" style="width:100% !important;" @click="getReceipts('/api/getAllReceipts')">Search</button>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
	<!-- main row for all icons  -->
	<div class="col-lg-12">
		<div class="card card-danger card-outline">
			<div class="card-body overflow-auto">
				<table class="table table-hover table-striped table-bordered">
				<thead>
					<tr>
                        <th scope="col">Branch</th>
						<th scope="col">SAP Doc Entry</th>
                        <th scope="col">Timestamp</th>
						<th scope="col">Mobile Number</th>

						<th scope="col">Used Amount</th>
						<th scope="col">Total Amount Collected</th>
						<th scope="col">Used</th>
						<th scope="col">View</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="j in receipts">
                        <td>{{j.branch_code}}</td>
						<td><p>No: {{j.sap_doc_num}}</p>
                        <p>Entry: {{j.sap_doc_entry}}</p></td>
                        <td>{{j.created_at | timeStamp}}</td>
						<td>{{j.mobile_number}}</td>

						<td>{{j.used_amount}}</td>
						<td>{{j.total_amount_collected}} &nbsp; <span class="badge badge-secondary" @click="viewPayments(j)"><i class="fa fa-search"></i>Payments</span></td>
						<td v-if="j.used==true">Used</td>
                        <td v-if="j.used!=true">Unused</td>
						<td>
							<button class="btn btn-primary" @click="view(j.id)">Print</button>
							<button class="btn btn-danger" @click="deleteReceipt(j.id)">Cancel</button>
						</td>
					</tr>
				</tbody>
			</table>
		  </div>
		  <div class="card-footer">
				<pagination :pagination="pagination"
		     	@prev="getReceipts(pagination.prevPageUrl)"
		      @next="getReceipts(pagination.nextPageUrl)"
		    ></pagination>
			</div>
		</div>
	</div>
<!-- row end -->
</section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
<!--        </div>-->
<!--        <div v-if="!$gate.isBranchManager()">-->
<!--             <access-denied></access-denied>-->
<!--        </div>-->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination: Pagination},

        created(){
            this.getBranches();
        	this.getReceipts();
        },

        data(){
        	return {
        		receipts: [],
                branches:[],
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		results: '',
         		params: new Form({
		       		phone: '',
                    branch:'',
		       		sapdoc: '',
		       		gatepass: '',
		       		minimum: '',
		       		maximum: '',
		       		from_date: '',
		       		to_date: '',
		       		draft_order_id: '',
		       		order_id: '',
		       		used: '',
		       		cancelled: '',
		       		receipt_id: '',
		       		against: ''
		       	})
        	}
        },

        methods: {
        	getReceipts(url="/api/getAllReceipts"){
        		axios.post(url, {results: this.results, params: this.params})
        		.then(response => {
        			this.receipts = response.data.data.data;
        			this.configPagination(response.data.data);
        		})
        	},

            getBranches(){
                if(this.usertype == 'zonal-manager'){
                    axios.post("/api/getZonalManagerBranches")
                        .then(response => {
                            this.branches = response.data;
                        });
                }
                else{
                    axios.post("/api/getSAPBranches")
                        .then(response => {
                            this.branches = response.data;
                        })
                }
            },

        	configPagination(data){
		    		this.pagination.lastPage=data.lastPage;
		       	this.pagination.currentPage=data.current_page;
		  	  	this.pagination.total=data.total;
		      	this.pagination.lastPageUrl=data.last_page_url;
		     		this.pagination.nextPageUrl=data.next_page_url;
		     		this.pagination.prevPageUrl=data.prev_page_url;
		   		 	this.pagination.from=data.from;
		      	this.pagination.to=data.to;
		  		},

		  		view(id){
		  			this.$router.push('/receipt/'+id);
		  		},

		  		deleteReceipt(id){
		  			axios.post("/api/cancelReceipt", {id: id})
		  			.then(response => {
		  				if(response.data == 1){
		  					toast.fire({
		  						icon: 'success',
		  						title: 'Receipt Cancelled'
		  					});
		  					this.getReceipts();
		  				}
		  				else{
		  					toast.fire({
		  						icon: 'error',
		  						title: 'Receipt Cannot be Cancelled'
		  					});
		  				}
		  			})
		  		},

            viewPayments(receipt){
                    this.$router.push('/reports/payments/general-report/'+receipt.id);
            },

		  		reset(){
		  			this.results = '';
		  			this.phone = '';
		  			this.sapdoc = '';
         		this.gatepass = '';
         		this.minimum = '';
         		this.maximum = '';
                 this.params.reset();
         		this.getReceipts();
		  		}
        }
    }
</script>
